import * as React from 'react';
import InputLabel from '@material-ui/core/InputLabel';

const CustomInputLabel = (props) => {
    return <InputLabel {...props} />;
};

export { CustomInputLabel as InputLabel };
